class BackTopTopButton extends HTMLElement {
  constructor() {
    super();
    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => this.backToTop());
  }
  backToTop() {
    if (typeof lenis !== 'undefined') {
      lenis.scrollTo('top');
    } else {
      window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
    }
  }
}

customElements.define('back-to-top', BackTopTopButton);
